import cn from 'clsx'
import ArrowSVG from '~/public/svg/arrow.svg'
import { Link } from '../link'
import s from './button.module.css'

export function Button({ label, className, ...props }) {
  return (
    <Link
      className={cn(
        s.btn,
        'dr-gap-10 dr-rounded-9999 dr-px-38 dr-py-12 transition-all duration-300 inline-flex',
        className
      )}
      {...props}
    >
      <span className="cta-sb-l flex-shrink-0">{label || 'Get started'}</span>
      <ArrowSVG className="dr-w-16" />
    </Link>
  )
}
